<template>
  <div id="app" class="bg-gray-100 min-h-screen font-yahei">
    <router-view />
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  name: 'app',
  computed: {
    user () {
      return this.$store.state.user
    }
  },
  created () {
    this.gettoken()
    if (this.$h.empty(this.user)) {
      this.$store.dispatch('getUser', this)
    }
  },
  methods: {
    gettoken () {
      let url = 'https://m.yooshifu.com/groupon.html?'
      let params = {
        params: {
          appurl: url
        }
      }
      this.$http.get(this.$api.wxtoken, params).then(res => {
        let { data, status } = res
        if (status) {
          return this.$toast(data.errmsg)
        }
        this.$store.commit('updateWxToken', data)
        let that = this
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature, // 必填，签名
          jsApiList: ['scanQRCode', 'getLocation', 'chooseWXPay', 'updateTimelineShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'onMenuShareQQ', 'onMenuShareQZone', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
        })
        wx.ready(() => {
          that.getlocation()
          that.$store.commit('updateWxState', true)
        })
      })
    },
    loading () {
      this.$toast.loading({
        mask: false,
        duration: 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: '加载中...'
      })
    },
    getlocation () {
      // 设定一个超时时间
      let that = this
      wx.getLocation({
        type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function (res) {
          that.$store.commit('updateLocation', { lon: res.longitude, lat: res.latitude })
          // 如果用户已登录，则更新用户坐标
          if (that.user) {
            let params = { lon: res.longitude, lat: res.latitude }
            that.$http.post(that.$api.locations, { data: params })
          }
        }
      })
    }
  }
}
</script>
<style src="@/assets/css/tailwind.css">
</style>
<style>
  input {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
</style>
